<script>
import EmptyPerson from '@asar-studio/rusdram-svgs/dist/illustrations/unkown-person.svg'

export default {
  props: { reviews: { type: Array, default: () => [] } },
  setup() {
    return { EmptyPerson }
  }
}
</script>

<template>
  <div class="grid grid-cols-2 gap-7 pt-3" v-if="reviews.length">
    <div class="col-start-1 col-end-3">
      <h4 class="text-xl font-sans text-dark-gray">Отзывы и рецензии</h4>
    </div>
    <article
      class="flex flex-col space-y-3"
      v-for="review in reviews"
      :key="review.name"
    >
      <div class="col-start-1 col-end-13">
        <h3 class="text-xl font-sans text-primary">
          {{ review.name }}
        </h3>
      </div>
      <div class="grid grid-cols-12 gap-x-5 gap-y-3">
        <div class="col-start-1 col-end-5 rounded-xl overflow-hidden h-48">
          <img
            loading="lazy"
            class="w-full h-full object-cover bg-gray-200"
            :src="EmptyPerson"
            alt="Лиана Юрченко о постановке «Кьоджинские перепалки»‎"
          />
        </div>
        <div class="col-start-5 col-end-13 v-html">
          <p>
            {{ review.text }}
          </p>
        </div>
      </div>
    </article>
  </div>
</template>
